import { WifiOff } from "lucide-react";
import { useOnline } from "@/lib/useInstall.ts";

/** A quiet strip when the device has no connection. The game itself needs one, so say so before an error does. */
export function OfflineBanner() {
  const online = useOnline();
  if (online) return null;
  return (
    <div role="status" className="flex items-center justify-center gap-2 bg-secondary px-4 py-2 text-center font-ui text-xs text-secondary-foreground">
      <WifiOff className="size-3.5 shrink-0" aria-hidden />
      <span>You’re offline. Your stars and streak are safe on this device; reconnect to play.</span>
    </div>
  );
}
